// extracted by mini-css-extract-plugin
module.exports = {"infoElement":"card_infoElement__M05fO","product":"card_product__2tq1S","infoKey":"card_infoKey__ChZza","title":"card_title__1UyFK","card":"card_card__2jNI0"};